module.exports = __webpack_public_path__ + "static/media/photo133.ec34f2fd.jpg";